import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/slack-hash': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M446.2 270.4C440 251.4 419.3 241.3 400.2 247.5L354.8 262.6 324.5 172.6 369.9 157.5C389 151.3 399 130.7 392.9 111.6 386.7 92.6 366 82.5 346.9 88.7L301.5 103.8 285.8 56.8C279.6 37.8 258.9 27.7 239.8 33.9 220.7 40.1 210.7 60.7 216.8 79.8L232.5 126.8 139.1 158 123.4 111C117.2 92 96.5 81.9 77.4 88.1 58.3 94.3 48.3 114.9 54.4 134L70.1 181 24.8 196C5.7 202.2-4.3 222.8 1.8 241.9 6.8 256.4 20.9 265.9 35.4 266.5 42.2 267.5 47.4 264.9 93.1 249.7L123.4 339.7 78 354.8C59 361 48.9 381.7 55 400.7 60 415.2 74.1 424.7 88.6 425.3 95.4 426.3 100.6 423.7 146.3 408.5L162 455.5C167.9 472.4 186.7 484.5 208 478.4 227.1 472.2 237.1 451.6 231 432.5L215.3 385.5 308.9 354.2 324.6 401.2C330.5 418.1 349.3 430.2 370.6 424.1 389.7 417.9 399.7 397.3 393.6 378.2L377.9 331.2 423.3 316.1C442.3 310.1 452.4 289.4 446.2 270.4zM192.1 317.6L161.8 227.4 255.3 196.1 285.6 286.3 192.1 317.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/slack-hash.js
// module id = WoK6
// module chunks = 144